import React from 'react';
import { connect } from 'react-redux';
import Auth from "../auth";
import { fetchSellersApi } from '../api/axios';
import { toast } from 'react-toastify';
import ClickOutsideHandler from './General/ClickOutsideHandler';

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideLogout: true,
            nombreTienda: "",
            urlLogo: ""
        }
    }

    componentDidMount() {
        if (this.props.tipoUsuario === 3 || this.props.tipoUsuario === 4) {
            this.obtenerDatosSeller();
        }
    }

    async obtenerDatosSeller() {
        let response = null;
        try {
            response = await fetchSellersApi({ idSeller: this.props.idSeller });

            let seller = response.elementos[0];
            let nombreTienda = "";

            if (seller.nombreTienda !== null) {
                if (seller.nombreTienda.length < 20) {
                    nombreTienda = seller.nombreTienda;
                } else {
                    nombreTienda = seller.nombreTienda.substring(0, 20) + "...";
                }
            } else {
                nombreTienda = seller.razonSocial;
            }

            this.setState({ 
                nombreTienda: nombreTienda, 
                urlLogo: seller.logo 
            });

        } catch (e) {
            toast.error("No se pudieron obtener los datos del seller.");
            return;
        }
    }

    handleClickOutside = () => {
        this.setState({ hideLogout: true });
    };

    onLogout() {
        Auth.logout();
        this.props.history.push("/login")
    }


    render() {

        const { hideLogout, urlLogo } = this.state;
        const isSeller = this.props.tipoUsuario === 3 || this.props.tipoUsuario === 4;

        return (
            <div className="container allow-pointer-cursor prevent-select">
                <div className="row" onClick={() => this.setState({hideLogout: !hideLogout})}>
    
                    <div className="col-auto" hidden={!isSeller}>
                        <img className="avatar-logo rounded-circle" src={urlLogo} alt="logo_img"/>
                    </div>
    
                    <div className="nav-link dropdown-toggle waves-effect waves-dark profile-pic col-auto">
                        <h6 className="d-inline color-blanco-megatone hidden-md-down px-1 mt-1">
                        {
                            isSeller ?  this.state.nombreTienda : this.props.userName
                        }
                        </h6>
                        <i className="fa fa-angle-down color-blanco-megatone px-1"/>
                    </div>

                    {!hideLogout && (
                        <ClickOutsideHandler onClickOutside={this.handleClickOutside}>
                            <div 
                                className="col-4 col-sm-3 col-md-2 col-lg-1 p-2 text-center logout hover-background-color item-popout animated headShake" 
                                onClick={(e) => (e.stopPropagation, this.onLogout())}
                            >
                                <i className="color-gris-megatone fa fa-power-off p-1"/> Salir
                            </div>
                        </ClickOutsideHandler>
                    )}
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    tipoUsuario: state.general.tipoUsuario,
    idSeller: state.general.idSeller,
    userName: state.general.userName
})

export default connect(mapStateToProps) (Menu);